import { z } from "zod";

export const SimpleErrorObject = z.object({
  message: z.string()
});

export const failedResponses = {
  400: SimpleErrorObject,
  403: SimpleErrorObject,
  500: SimpleErrorObject
};
